import {createContext, useEffect, useState} from 'react';
import {useGlobalConfigApi} from './globalConfig';

export const GlobalSettingsState = createContext({});

const GlobalSettingsProvider = ({ children }) => {
    const {getGlobalSettings} = useGlobalConfigApi('global-settings');
    const [globalSettings, setGlobalSettings] = useState({});

    useEffect(() => {
        getGlobalSettings().then((data) => {
            setGlobalSettings(data.config);
        })
    }, [])

    return (
        <GlobalSettingsState.Provider value={{ globalSettings, setGlobalSettings }}>
            {children}
        </GlobalSettingsState.Provider>
    )
}

export default GlobalSettingsProvider;